var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinPostsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.linkedin{fill:url(#linkedin-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28434,
    stopColor: "#4495cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#0a66c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3990"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "linkedin",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M66.56781,25.63739h-33.13562c-4.30487,0-7.79474,3.48981-7.79474,7.79474v33.13568c0,4.30487,3.48987,7.79474,7.79474,7.79474h33.13562c4.30493,0,7.7948-3.48987,7.7948-7.7948v-33.13556c0-4.30499-3.48987-7.7948-7.7948-7.7948ZM50.6181,65.72644c0,.68274-.55347,1.23615-1.23615,1.23615h-14.77673c-.68268,0-1.23615-.55341-1.23615-1.23615v-1.72742c0-.68268.55347-1.23615,1.23615-1.23615h14.77673c.68268,0,1.23615.55347,1.23615,1.23615v1.72742ZM66.63092,58.3349c0,.68274-.55347,1.23621-1.23615,1.23621h-30.78955c-.68268,0-1.23615-.55347-1.23615-1.23621v-1.72736c0-.68274.55347-1.23621,1.23615-1.23621h30.78955c.68268,0,1.23615.55347,1.23615,1.23621v1.72736ZM66.63092,48.67554c0,1.14661-.9295,2.07611-2.07611,2.07611h-29.10962c-1.14661,0-2.07611-.9295-2.07611-2.07611v-12.31067c0-1.14661.9295-2.07611,2.07611-2.07611h29.10962c1.14661,0,2.07611.9295,2.07611,2.07611v12.31067Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinPostsScraper);
export default __webpack_public_path__ + "static/media/linkedin-posts-scraper.5ba52b1caf1798d34a25b8e7c1e248b5.svg";
export { ForwardRef as ReactComponent };